import { getTenant } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { useAppSelector } from "@/stores/hook";
import { useQuery } from "@tanstack/react-query";

export function useCurrentTenant() {
  const {
    currentUser: { user },
  } = useAppSelector((state) => state.auth);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["current-tenant"],

    queryFn: async () => {
      const response = await axiosInstance.get(getTenant);
      return {
        tenant: response.data?.tenant || [],
        analytics: response.data?.total || response.data?.total || {},
      };
    },
  });
  return {
    tenant: data?.tenant || [],
    user,
    isLoading,
    error,
    refetch,
  };
}
